// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1y3Hw","bigColWidth":"Table_bigColWidth__31quz","biggerColWidth":"Table_biggerColWidth__1EI47","row":"Table_row__13pVi","col":"Table_col__YQ-Vh"};